function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M17.993 31.405c25-18.75 50-12.5 100-25s156.25 0 175 25 31.25 56.25 0 75-75 0-125 0-131.25-12.5-150-25-25-31.25 0-50z",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 3
});

function SvgBlob(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 313.534 116.237"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMTMuNTM0IDExNi4yMzciPgogIDwhLS0gPHBhdGggdmVjdG9yLWVmZmVjdD0ibm9uLXNjYWxpbmctc3Ryb2tlIiBkPSJNMTcuOTkzIDMxLjQwNWMyNS0xOC43NSA1MC0xMi41IDEwMC0yNXMxNTYuMjUgMCAxNzUgMjUgMzEuMjUgNTYuMjUgMCA3NS03NSAwLTEyNSAwLTEzMS4yNS0xMi41LTE1MC0yNS0yNS0zMS4yNSAwLTUweiIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMiIvPiAtLT4KCTxwYXRoIGQ9Ik0xNy45OTMgMzEuNDA1YzI1LTE4Ljc1IDUwLTEyLjUgMTAwLTI1czE1Ni4yNSAwIDE3NSAyNSAzMS4yNSA1Ni4yNSAwIDc1LTc1IDAtMTI1IDAtMTMxLjI1LTEyLjUtMTUwLTI1LTI1LTMxLjI1IDAtNTB6IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIzIi8+Cjwvc3ZnPg==";
export { SvgBlob as ReactComponent };